import { render, staticRenderFns } from "./DuplicatePublicationModal.vue?vue&type=template&id=4c7d0c1c&scoped=true&"
import script from "./DuplicatePublicationModal.vue?vue&type=script&lang=js&"
export * from "./DuplicatePublicationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c7d0c1c",
  null
  
)

export default component.exports